<template>
  <div id="wxlogin">
    <div
      class="wxLogin-qrCode-box"
      @mouseenter="qrCodeBoxMouseEnter"
      @mouseleave="qrCodeBoxMouseLeave"
    >
      <div class="wxLogin-qrCode">
        <WxQrcodeLogin
          @onSuccessScan="onSuccessScan"
          ref="wxLoginQrcodeRef"
          @onSuccessToCanvas="onSuccessToCanvas"
          @onAfterWxLogin="onAfterWxLogin"
          operType="LOGIN"
          title=""
          wxDefaultTip=""
          wxDefaultTipTwo=''
          :qrCodeConfig="qrCodeConfig"
        />
        <div
          class="qrcode-error-mask"
          v-if="isErrorMasker"
        >
          <div class="qrcode-error-mask-text">二维码已失效</div>
          <div
            class="qrcode-error-mask-btn"
            @click="qrcodeErrorBtn"
          >刷新</div>
        </div>
      </div>
      <div class="phone-orange"></div>
    </div>
    <div
      class="wxLogin_info"
      v-if="!isScan"
    >
      打开
      <span>手机微信</span> 扫描二维码
    </div>
    <div
      class="wxLogin_info"
      v-if="isScan"
    >
      <span>扫描成功请在微信中点击确认即可登录</span>
    </div>
    <div class="wxLogin_link">
      <span class="wxLogin_link_findPass"></span>
      <span
        class="wxLogin_link_findPass_btn"
        @click="onFindPass"
      >忘记密码</span>
      <span class="wxLogin_link_register"></span>
      <a
        class="wxLogin_link_register_btn"
        @click="toRegister"
      >免费注册</a>
    </div>
  </div>
</template>
<script>
// import Cookies from 'js-cookie';
import WxQrcodeLogin from '@/components/weixin/WxQrcodeLogin';
import eventBus from '@/plugins/event-bus';
import $ from 'jquery';
export default {
  name: 'wxlogin',
  components: {
    WxQrcodeLogin
  },
  data() {
    return {
      qrCodeConfig: {
        width: 147,
        height: 147,
        margin: 0
      },
      timer: null,
      wxLoginTime: 300,
      isErrorMasker: false,
      isScan: false
    };
  },
  methods: {
    onAfterWxLogin: function(user) {
      this.$emit('onLoginSuccess', user);
    },
    onFindPass: function() {
      eventBus.$emit('isFindPassShow', true);
    },
    qrCodeBoxMouseEnter: function() {
      if (!this.isErrorMasker) {
        $('#wxlogin .wxLogin-qrCode')
          .stop()
          .animate({ left: '5%' }, function() {
            $('#wxlogin .phone-orange').css({ display: 'block' });
          });
      }
    },
    qrCodeBoxMouseLeave: function() {
      $('#wxlogin .phone-orange').css({ display: 'none' });
      $('#wxlogin .wxLogin-qrCode')
        .stop()
        .animate({ left: '25%' });
    },
    onSuccessToCanvas: function() {
      this.wxLoginTime = 300;
      this.isErrorMasker = false;
      this.timer = setInterval(() => {
        if (this.wxLoginTime <= 0) {
          this.isErrorMasker = true;
          clearInterval(this.timer);
          this.timer = null;
        } else {
          this.wxLoginTime--;
        }
      }, 1000);
    },
    qrcodeErrorBtn: function() {
      this.$refs.wxLoginQrcodeRef.init();
    },
    onSuccessScan: function() {
      clearInterval(this.timer);
      this.timer = null;
      this.isScan = true;
    },
    toRegister: function() {
      // Cookies.remove('orgRegisterData');
      sessionStorage.removeItem('orgRegisterData');
      this.$router.push('/org/register/stepone');
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  }
};
</script>
<style lang="less" scoped>
#wxlogin {
  font-family: Arial, Verdana, '宋体';
  .wxLogin-qrCode-box {
    height: 170px;
    width: 100%;
    position: relative;
  }
  .phone-orange {
    width: 141px;
    height: 168px;
    position: absolute;
    right: 0;
    top: 0;
    display: none;
    background: url('../../assets/img/pc_icon_phone-bg1.png') no-repeat;
    background-size: auto 168px;
  }
  .wxLogin-qrCode {
    border: 1px solid #f4f4f4;
    padding: 8px;
    width: 155px;
    overflow: hidden;
    height: 147px;
    position: absolute;
    left: 25%;
  }
  .qrcode-error-mask {
    height: 163px;
    width: 171px;
    background-color: rgba(0, 0, 0, 0.6);
    position: absolute;
    left: 0;
    top: 0;
    z-index: 2;
  }
  .qrcode-error-mask-text {
    color: #fbfbfb;
    font-size: 14px;
    margin-top: 55px;
    text-align: center;
    margin-bottom: 20px;
  }
  .qrcode-error-mask-btn {
    width: 80px;
    height: 30px;
    background: #e4393c;
    color: #fbfbfb;
    font-size: 14px;
    line-height: 30px;
    text-align: center;
    margin: 0 auto;
    cursor: pointer;
  }
  .wxLogin_info {
    padding-top: 25px;
    padding-bottom: 16px;
    color: #666;
    text-align: center;
    font-size: 12px;
    span {
      color: #e4393c;
      margin-right: 10px;
    }
  }
  .wxLogin_link {
    margin-left: 60px;
    font-family: 'microsoft yahei';
    color: #999;
    line-height: 25px;
    .wxLogin_link_findPass {
      padding: 3px 13px;
      background: url('../../assets/img/qr-coagent.png') no-repeat;
      margin-right: 5px;
    }
    .wxLogin_link_findPass_btn {
      cursor: pointer;
    }
    .wxLogin_link_register {
      padding: 3px 13px;
      background: url('../../assets/img/qr-coagent.png') -27px 0px no-repeat;
      margin-right: 5px;
      margin-left: 42px;
    }
    .wxLogin_link_register_btn {
      cursor: pointer;
      color: #999;
    }
  }
}
</style>
